import { StorageRootDto } from '..';
import { ValueEncoder } from 'DiscoveryEngine.TS/Utils';


export class SuperServerDto extends StorageRootDto {

    public Name: string;
    public ServerUrl: string;
    public ServerApiKey: string;
    public SyncInterval: number;  // Minutes
	public LastSyncStartTime: string;
	public LastSyncEndTime: string;
    public SyncEnabled: boolean;
    public AwolEnabled: boolean;
	public AwolDays: number;
	public AwolHours: number;
	public AwolMinutes: number;
	public Awol: boolean;

    constructor() {
        super();

        this.Name = "";
        this.ServerUrl = "";
        this.ServerApiKey = "";
        this.SyncInterval = 0;
		this.LastSyncStartTime = "";
		this.LastSyncEndTime = "";
        this.SyncEnabled = false;
        this.AwolEnabled = false;
		this.AwolDays = 0;
		this.AwolHours = 0;
		this.AwolMinutes = 0;
        this.Awol = false;
    }

    public get HasName(): boolean {
        return !!this.Name;
    }

    public get HasServerUrl(): boolean {
        return !!this.ServerUrl;
    }

    public get HasServerApiKey(): boolean {
        return !!this.ServerApiKey;
    }

    public get HasSyncInterval(): boolean {
        return (this.SyncInterval > 0);
    }

	public get HasLastSyncStartTime(): boolean {
		return !!this.LastSyncStartTime;
	}

	public get HasLastSyncEndTime(): boolean {
		return !!this.LastSyncEndTime;
	}
    
	public Write(obj: any, context: any): void {
		obj.super_server = {};
		obj = obj.super_server;

		super.Write(obj, context);

        if (this.HasName) {
            obj.name = this.Name;
        }
		if (this.HasServerUrl) {
			obj.server_url = this.ServerUrl;
		}
		if (this.HasServerApiKey) {
            obj.server_api_key = this.ServerApiKey;
        }
        if (this.HasSyncInterval) {
            obj.sync_interval = ValueEncoder.EncodeInteger(this.SyncInterval);
        }
		if (this.HasLastSyncStartTime) {
			obj.last_sync_start_time = this.LastSyncStartTime;
		}
		if (this.HasLastSyncEndTime) {
			obj.last_sync_end_time = this.LastSyncEndTime;
		}

        obj.sync_enabled = ValueEncoder.EncodeBoolean(this.SyncEnabled);
		obj.awol_enabled = ValueEncoder.EncodeBoolean(this.AwolEnabled);
		obj.awol_days = ValueEncoder.EncodeInteger(this.AwolDays);
		obj.awol_hours = ValueEncoder.EncodeInteger(this.AwolHours);
		obj.awol_minutes = ValueEncoder.EncodeInteger(this.AwolMinutes);
		obj.awol = ValueEncoder.EncodeBoolean(this.Awol);   
	}

	public Read(obj: any, context: any): void {
		if (!obj.super_server)
			throw new Error();
		obj = obj.super_server;

		super.Read(obj, context);

        if (obj.name !== undefined) {
            this.Name = obj.name;
        }
		if (obj.server_url !== undefined) {
			this.ServerUrl = obj.server_url;
		}
		if (obj.server_api_key !== undefined) {
			this.ServerApiKey = obj.server_api_key;
		}
		if (obj.sync_interval !== undefined) {
			this.SyncInterval = ValueEncoder.DecodeInteger(obj.sync_interval);
		}
		if (obj.last_sync_start_time !== undefined) {
			this.LastSyncStartTime = obj.last_sync_start_time;
		}
		if (obj.last_sync_end_time !== undefined) {
			this.LastSyncEndTime = obj.last_sync_end_time;
		}
		if (obj.sync_enabled !== undefined) {
			this.SyncEnabled = ValueEncoder.DecodeBoolean(obj.sync_enabled);
		}
		if (obj.awol_enabled !== undefined) {
			this.AwolEnabled = ValueEncoder.DecodeBoolean(obj.awol_enabled);
		}
		if (obj.awol_days !== undefined) {
			this.AwolDays = ValueEncoder.DecodeInteger(obj.awol_days);
		}
		if (obj.awol_hours !== undefined) {
			this.AwolHours = ValueEncoder.DecodeInteger(obj.awol_hours);
		}
		if (obj.awol_minutes !== undefined) {
			this.AwolMinutes = ValueEncoder.DecodeInteger(obj.awol_minutes);
		}
		if (obj.awol !== undefined) {
			this.Awol = ValueEncoder.DecodeBoolean(obj.awol);
		}
	}
}
